var _defs, _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlashbang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "19px",
    height: "40px",
    viewBox: "0.981 0 19 40",
    enableBackground: "new 0.981 0 19 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.558,9.661V7.897C5.853,7.809,5.5,7.471,5.5,6.882C5.5,6.5,5.632,6.25,5.896,6.133L6.778,6h4.851l4.102,6.57V26.46 l-2.074,1.015l-0.66-0.132c-0.147-0.265-0.089-0.515,0.175-0.75c0.235-0.207,0.589-0.441,1.06-0.707l0.616-0.309V13.188 l-1.763-1.014v2.073l-1.06,0.97v2.073h-0.441v2.116h0.441v2.205h-0.441v2.117h0.441v2.205h-0.441v2.116h0.441v2.029l1.06,1.808v1.5 c0,0.411-0.206,0.616-0.618,0.616h-7.85C4.204,34,4,33.795,4,33.384v-1.5l1.014-1.808v-2.029h0.485v-2.116H5.014v-2.205h0.485V21.61 H5.014v-2.205h0.485V17.29H5.014v-2.073L4,14.247v-2.822c0-0.411,0.204-0.618,0.616-0.618h0.618L6.558,9.661L6.558,9.661z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "sliceCopy_x5F_8_1_",
    x: 19.73,
    fill: "none",
    width: 35.337,
    height: 40
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "sliceCopy_x5F_7_1_",
    fill: "none",
    width: 19.73,
    height: 40
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashbang);
export default __webpack_public_path__ + "static/media/flashbang.29d2a6a72245ba2d326f71002fa23336.svg";
export { ForwardRef as ReactComponent };